// src/hooks/useHandleIntent.js
import { useCallback } from 'react';

const useHandleIntent = ({
    fetchProductCookie,
    handleSetMessage,
    scrollToBottom,
    setShowFormQuote,
    setShowFormSupplier,
    setIsInputDisabled,
    setIsMenuDisabled,
    setMessages,
    isLoggedIn,
}) => {
    return useCallback(async (intent, userInput) => {
        switch (intent) {
            case "give_quotes":
                if (!isLoggedIn) {
                    handleSetMessage("Please login to access this functionality", "system");
                    setIsMenuDisabled(false);
                    setIsInputDisabled(false);
                } else {
                    await fetchProductCookie();
                    setShowFormQuote(true);
                    setIsInputDisabled(true);
                }
                break;
            case "become_supplier":
                if (!isLoggedIn) {
                    handleSetMessage("Please login to access this functionality", "system");
                    setIsMenuDisabled(false);
                    setIsInputDisabled(false);
                } else {
                    await fetchProductCookie();
                    setShowFormSupplier(true);
                    setIsInputDisabled(true);
                }
                break;
            case "request_callback":
                handleSetMessage("Loading Callback Form Please wait...","system")
                setTimeout(()=> {
                    setMessages((prevMessages) =>
                        prevMessages.filter((msg) => msg.text !== "Loading Callback Form Please wait...")
                    );
                    handleSetMessage("Please fill out the form below to receive a call-back:\n\n<iframe src='https://forms.zohopublic.com/ofbusiness/form/OFBGeneralEnquiries1/formperma/knuCD4yxSoYIJ0CrE_7xVUPZ31foUYotH2QRBtSosNI' width=100% height=100% class='iframe-container'/>","system");
                    setIsInputDisabled(false);
                },10000)
                break;
            default:
                setIsInputDisabled(false);
                break;
        }
        setTimeout(() => {
            scrollToBottom();
        }, 100);
    }, [
        setMessages,
        fetchProductCookie,
        handleSetMessage,
        scrollToBottom,
        setShowFormQuote,
        setShowFormSupplier,
        setIsInputDisabled,
        isLoggedIn,
        setIsMenuDisabled
    ]);
};

export default useHandleIntent;
